import '@splidejs/splide/css/core';
import '../styles/main.css';

import './hero-slider/hero-slider.js';
import './ajax/load-more.js';
import './ajax/pr-listings.js';


window.addEventListener('scroll', (e) => adjustHeaderColor())
window.addEventListener('DOMContentLoaded', (e) => {
    adjustHeaderColor()
    addDefaultSelect()
})

//Adjusts header on scroll down
function adjustHeaderColor() {
    if (document.querySelector('body.home')) {

        const scrollDistance = window.scrollY || document.documentElement.scrollTop;
        const header = document.querySelector('.bottom-header')
        
        if (scrollDistance > 20) {
            header.style.background = '#fff'
        } else {
            header.style.background = 'transparent'
        }
      
    }
}

//Sets placeholder on translator select
function addDefaultSelect() {
    const firstOption = document.querySelector('.gt_selector')?.firstElementChild
    firstOption.setAttribute('selected', '')
}

